import { AppLayout } from '@/layouts/AppLayout';
import { Outlet, useLocation } from 'react-router';
import { SettingsTabs } from '@/components/settings/SettingsTabs';
import { useTranslation } from 'react-i18next';
import { getSettingsNavItemForPath } from '@/components/settings/settings-navigation.config';

export function SettingsLayout() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isOverview = pathname === '/settings';
  const activeItem = getSettingsNavItemForPath(pathname);

  const breadcrumbs = isOverview
    ? [{ href: '/settings', children: t('settings.title') }]
    : [
        { href: '/settings', children: t('settings.title') },
        {
          href: activeItem?.to ?? pathname,
          children: activeItem ? t(activeItem.labelKey) : t('settings.title'),
        },
      ];

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      {!isOverview && <SettingsTabs />}
      <Outlet />
    </AppLayout>
  );
}
